import { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Login-uitdaging (aal2): getoond wanneer een ingelogde gebruiker een geverifieerde
 * MFA-factor heeft maar de sessie nog op aal1 staat. Blokkeert de app tot de code klopt.
 * "Annuleren" logt uit (geen half-ingelogde staat).
 */
export default function MfaChallenge() {
  const { verifyMfaChallenge, signOut } = useAuth();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await verifyMfaChallenge(code);
      // Bij succes wordt mfaRequired false en rendert de app zichzelf.
    } catch {
      setError('Onjuiste code. Controleer de code in je app en probeer opnieuw.');
      setCode('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-dark">
      <div className="w-full max-w-sm">
        <div
          className="rounded-2xl p-8"
          style={{
            background: '#111116',
            border: '1px solid rgba(255,255,255,0.08)',
            boxShadow: '0 24px 80px rgba(0,0,0,0.6)',
          }}
        >
          <div className="flex flex-col items-center text-center mb-6">
            <div className="w-14 h-14 rounded-full bg-[#F598AF]/15 flex items-center justify-center mb-4">
              <ShieldCheck className="w-7 h-7 text-[#F598AF]" />
            </div>
            <h1 className="text-xl text-white font-bold">Verificatie</h1>
            <p className="text-sm text-white/50 mt-1">
              Voer de 6-cijferige code uit je authenticator-app in.
            </p>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <input
              inputMode="numeric"
              autoComplete="one-time-code"
              autoFocus
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              placeholder="000000"
              className="w-full px-4 py-3 rounded-xl border border-white/15 bg-surface text-foreground text-center text-2xl tracking-[0.4em] focus:outline-none focus:ring-2 focus:ring-[#F598AF]/50 transition-all"
            />
            {error && (
              <p className="text-sm text-red-300 bg-red-500/10 border border-red-400/30 rounded-lg px-3 py-2">
                {error}
              </p>
            )}
            <button
              type="submit"
              disabled={busy || code.length !== 6}
              className="w-full py-3 rounded-xl text-white font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ background: 'linear-gradient(135deg, #F598AF 0%, #e0476a 100%)' }}
            >
              {busy ? 'Controleren…' : 'Bevestigen'}
            </button>
            <button
              type="button"
              onClick={() => signOut()}
              className="w-full text-center text-xs text-white/40 hover:text-white/70 transition-colors pt-1"
            >
              Annuleren en uitloggen
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
